/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactWidgetCmaDetailsContent } from './ArtifactWidgetCmaDetailsContent';
import {
    ArtifactWidgetCmaDetailsContentFromJSON,
    ArtifactWidgetCmaDetailsContentFromJSONTyped,
    ArtifactWidgetCmaDetailsContentToJSON,
    ArtifactWidgetCmaDetailsContentToJSONTyped,
} from './ArtifactWidgetCmaDetailsContent';

/**
 * 
 * @export
 * @interface ArtifactWidgetCmaDetails
 */
export interface ArtifactWidgetCmaDetails {
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetCmaDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetCmaDetails
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetCmaDetails
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetCmaDetails
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetCmaDetails
     */
    kind: ArtifactWidgetCmaDetailsKindEnum;
    /**
     * 
     * @type {ArtifactWidgetCmaDetailsContent}
     * @memberof ArtifactWidgetCmaDetails
     */
    content: ArtifactWidgetCmaDetailsContent;
}


/**
 * @export
 */
export const ArtifactWidgetCmaDetailsKindEnum = {
    WidgetCmaDetails: 'widget-cma-details'
} as const;
export type ArtifactWidgetCmaDetailsKindEnum = typeof ArtifactWidgetCmaDetailsKindEnum[keyof typeof ArtifactWidgetCmaDetailsKindEnum];


/**
 * Check if a given object implements the ArtifactWidgetCmaDetails interface.
 */
export function instanceOfArtifactWidgetCmaDetails(value: object): value is ArtifactWidgetCmaDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactWidgetCmaDetailsFromJSON(json: any): ArtifactWidgetCmaDetails {
    return ArtifactWidgetCmaDetailsFromJSONTyped(json, false);
}

export function ArtifactWidgetCmaDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactWidgetCmaDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactWidgetCmaDetailsContentFromJSON(json['content']),
    };
}

export function ArtifactWidgetCmaDetailsToJSON(json: any): ArtifactWidgetCmaDetails {
    return ArtifactWidgetCmaDetailsToJSONTyped(json, false);
}

export function ArtifactWidgetCmaDetailsToJSONTyped(value?: ArtifactWidgetCmaDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactWidgetCmaDetailsContentToJSON(value['content']),
    };
}

